$(document).ready(() => {
  function generateIframe(signatureId) {
    const configuration = {};
    configuration.redirectionMode = "OUT";
    const iframeEndpoint = $("#iframeContainerId").data("universign-iframe-endpoint");
    universignSigInit("iframeContainerId", signatureId, configuration, iframeEndpoint);
  }

  if ($("#signature-subscription-id").length) {
    App.cable.subscriptions.create(
      { channel: "SignatureChannel", subscription_id: $("#signature-subscription-id").data("id") }, {
        received(data) {
          if (data.status == "success") {
            $("#signature_button").removeClass("disabled");
            $("#dymanic_signature_instructions").text("Votre bulletin est généré, vous pouvez le signer dès maintenant");
            $("#loader").addClass("d-none");
            $("#success_icon").removeClass("d-none");

            $("#signature_button").on("click", () => {
              generateIframe(data.signature_id);
              $("#signature_page_title").text("Signature de votre souscription");
              $("#dynamic_text_content").addClass("d-none");
              $("#iframeContainerId").removeClass("d-none");
              $("#paddingContainer").removeClass("d-none");
            });

          } else {
            $("#dymanic_signature_instructions").text("Une erreur est survenue. Nos équipes sont en train de vérifier l'erreur. Merci de réessayer ultérieurement.");
            $("#loader").addClass("d-none");
          }
        }
      }
    );
  };
});
